import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './SubscriptionPlan.module.css';

const SubscriptionPlanHero = () => (
  <div className={css.heroWrapper}>
    {/* Floating Decorative Crescent Shapes (Figma Ellipse 9 & 10) */}
    <div className={css.heroDecoLeft} aria-hidden="true">
      <svg
        width="58"
        height="49"
        viewBox="0 0 58 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M58 34.8123C53.3785 41.8017 46.1667 46.671 37.9512 48.3489C29.7356 50.0269 21.1893 48.376 14.1922 43.7596C7.19514 39.1432 2.32053 31.9394 0.640736 23.7329C-1.03906 15.5263 0.613569 6.98938 5.23505 1.41981e-06L31.6175 17.4062L58 34.8123Z"
          fill="#FEC220"
        />
      </svg>
    </div>
    <div className={css.heroDecoRight} aria-hidden="true">
      <svg
        width="59"
        height="50"
        viewBox="0 0 59 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-5.99641e-05 14.4372C4.70111 7.31947 12.0372 2.36081 20.3944 0.652058C28.7516 -1.0567 37.4453 0.624426 44.5631 5.32559C51.6808 10.0268 56.6394 17.3629 58.3482 25.7201C60.0569 34.0773 58.3758 42.771 53.6746 49.8887L26.8373 32.1629L-5.99641e-05 14.4372Z"
          fill="#D64000"
        />
      </svg>
    </div>

    <h1 className={css.title}>
      <span className={css.titleLine1}>
        <FormattedMessage
          id="SubscriptionPlan.title.heading1Html"
          defaultMessage="Choose <span>a plan</span>"
          values={{
            span: chunks => <span className={css.titleOrange}>{chunks}</span>,
          }}
        />
      </span>
      <span className={css.titleLine2}>
        <FormattedMessage id="SubscriptionPlan.title.heading2" />
      </span>
    </h1>
    <p className={css.subtitle}>
      <FormattedMessage id="SubscriptionPlan.subtitle" />
    </p>
  </div>
);

export default SubscriptionPlanHero;
